'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class applicationModel extends ngDepModel
{
		
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	
	getValue(name){
		switch(name){
			case 'created':
			case 'updated':
			case 'submission_date':
				if(this[name] == 0){
					return '';
				}
				return this.s('$filter')('u2date')(this[name], 'dd/MM/y HH:mm (Z)');
			case 'a1_general_amount':
				return this.s('$filter')('currency')(this[name]);
			case 'status':
				return this.getClassifValue(name, 'application_status');
			case 'evaluation_stage':
				return this.getClassifValue(name, 'stages');
			case 'a1_general_has_previous':
				return this.getClassifValue(name, 'yesno');
			case 'coordinator_country_id':
				if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
					return this.getClassifValue(name, 'country');
				}
				break;
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
	
}